import { LocationSummary } from '../../app/ApiGen';
import { Normalised } from '../request';

export function toCoordinates(value: string): Normalised<LocationSummary>['coordinates'] {
  const latLngRegExp = /^(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)$/;
  const [lat, lng] = value.split(latLngRegExp).slice(1, 3);
  return { latitude: lat, longitude: lng };
}
